import React, { useState, useEffect } from 'react';
import { Calendar, Clock, X } from 'lucide-react';
import './DateTimePicker.css';

export default function DateTimePicker({ value, onChange, placeholder }) {
  const [showPicker, setShowPicker] = useState(false);
  const [dateVal, setDateVal] = useState('');
  const [timeVal, setTimeVal] = useState('12:00');

  useEffect(() => {
    if (value) {
      const d = new Date(value);
      setDateVal(d.toISOString().split('T')[0]);
      setTimeVal(d.toTimeString().slice(0, 5));
    }
  }, []);

  const handleApply = () => {
    if (dateVal && timeVal) {
      onChange(`${dateVal}T${timeVal}`);
      setShowPicker(false);
    }
  };

  const handleClear = (e) => {
    e.stopPropagation();
    onChange('');
    setDateVal('');
    setTimeVal('12:00');
  };

  const displayValue = value
    ? new Date(value).toLocaleString('ru', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    : '';


  const setPreset = (hours) => {
    const d = new Date();
    d.setHours(d.getHours() + hours);
    setDateVal(d.toISOString().split('T')[0]);
    setTimeVal(d.toTimeString().slice(0, 5));
  };

  return (
    <div className="dtp-wrapper">
      <div className="dtp-input" onClick={() => setShowPicker(!showPicker)}>
        <Calendar size={14} className="dtp-icon" />
        <span className={displayValue ? 'dtp-value' : 'dtp-placeholder'}>
          {displayValue || placeholder || 'Выбрать дату и время'}
        </span>
        {value && (
          <button className="dtp-clear" onClick={handleClear}><X size={12} /></button>
        )}
      </div>

      {showPicker && (
        <div className="dtp-dropdown">
          <div className="dtp-presets">
            <button onClick={() => setPreset(1)}>Через 1ч</button>
            <button onClick={() => setPreset(3)}>Через 3ч</button>
            <button onClick={() => setPreset(24)}>Завтра</button>
            <button onClick={() => setPreset(48)}>Через 2д</button>
          </div>
          <div className="dtp-fields">
            <div className="dtp-field">
              <label><Calendar size={12} /> Дата</label>
              <input type="date" value={dateVal} onChange={e => setDateVal(e.target.value)} />
            </div>
            <div className="dtp-field">
              <label><Clock size={12} /> Время</label>
              <input type="time" value={timeVal} onChange={e => setTimeVal(e.target.value)} />
            </div>
          </div>
          <div className="dtp-actions">
            <button className="btn btn-ghost btn-sm" onClick={() => setShowPicker(false)}>Отмена</button>
            <button className="btn btn-primary btn-sm" onClick={handleApply} disabled={!dateVal}>Применить</button>
          </div>
        </div>
      )}
    </div>
  );
}